var map = {
	"./apple.png": 39560,
	"./check.jpg": 32368,
	"./cosmotics.jpeg": 42547,
	"./dairy.png": 6773,
	"./hr.png": 79912,
	"./meat.png": 49355,
	"./pharmacy.png": 14741,
	"./security.png": 78956,
	"./store.png": 35327
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52792;